import { render } from "./HeaderButton.vue?vue&type=template&id=511dcfa3&scoped=true"
import script from "./HeaderButton.vue?vue&type=script&lang=js"
export * from "./HeaderButton.vue?vue&type=script&lang=js"

import "./HeaderButton.vue?vue&type=style&index=0&id=511dcfa3&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511dcfa3"]])

export default __exports__